import styled from 'styled-components';

import { baseSelectItem } from 'utils/style';
import AddressSuggestionItem from 'components/AddressModal/components/AddressSuggestionItem/container';

export default styled(AddressSuggestionItem)`
  ${baseSelectItem};
  height: 100%;
  padding: 6px 16px;

  .address {
    white-space: normal;
    color: var(--grey900);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .highlighted {
    font-weight: bold;
    color: var(--grey900);
  }
`;
